import '../../App.scss'
import Fade from 'react-reveal/Fade';
import { useHistory } from 'react-router'
export default function Hero() {
    const history = useHistory()
    return (
        <div className="Hero">
            <div className="HeroOverlay">
                <Fade bottom cascade>
                    <div className="CenterContent">
                        <div>
                        <h1>Uncovering the truth</h1>
                        <h2>Protecting the past</h2>
                        </div>
                        <div onClick={()=>history.push('/community')} className="MainButton">
                            Join The Community
                        </div>
                    </div>
                </Fade>
            </div>
        </div>
    );
}
